<template>
  <s-login-layout :state="state">
    <div>
      <form
        class="ba-relative ba-w-full md:ba-w-116"
        @submit.prevent="loginFormSubmit"
      >
        <s-lk-auth-input
          v-model="form.username"
          name="Логин"
          :disabled="formLoading"
          inverse
        />
        <s-lk-auth-input
          v-model="form.password"
          :disabled="formLoading"
          type="password"
          name="Пароль"
          inverse
        />

        <div class="md:ba-flex ba-justify-between ba-items-center ba-mt-8">
          <s-lk-checkbox
            v-model="form.rememberMe"
            :disabled="formLoading"
            class="s-lk-checkbox--white"
            label="Запомнить меня"
          />
          <router-link
            v-if="settings.canRemember"
            :to="{ name: 'recovery', query: { state } }"
            class="
              ba-inline-block
              ba-mt-3 md:ba-mt-0
              ba-opacity-35 md:ba-opacity-100
              ba-text-base md:ba-text-xl
              ba-underline ba-text-white ba-leading-none
            "
          >Забыли пароль?
          </router-link>
        </div>

        <s-captcha
          v-if="showCaptcha"
          class="ba-mt-15"
          :result.sync="captchResult"
          :refresh.sync="refreshCaptcha"
        />

        <s-error
          v-if="message"
          class="ba-absolute ba-inset-x-0 ba-mt-3 md:ba-mt-6"
          :message="message"
          :success="formSuccess"
        />

        <button
          class="s-lk-auth-button ba-mt-16 ba-mx-auto"
          type="submit"
          :disabled="formLoading"
        >Войти
        </button>
      </form>
    </div>
  </s-login-layout>
</template>

<script>
import SLoginLayout from "./s-login-layout";
import SLkAuthInput from "@/components/smena/s-lk-auth-input";
import SLkCheckbox from "@/components/smena/s-lk-checkbox";
import { loginMixin } from "@ba/visary-account-common-vue";
import { createSettings } from "@/utils/settings";
import SCaptcha from "@/components/smena/s-captcha";
import SError from "../../components/smena/s-error";

export default {
  name: "s-page-login",
  mixins: [loginMixin],
  components: {
    SError,
    SCaptcha,
    SLoginLayout,
    SLkCheckbox,
    SLkAuthInput
  },
  data() {
    return {
      settings: createSettings()
    };
  },
  computed: {
    message() {
      if (this.formError) {
        return "Введено неверное имя пользователя или пароль";
      }
      if (this.formSuccess) {
        return "Вход выполнен успешно";
      }
      return false;
    }
  },
  watch: {
    loginInfo() {
      this.settings = createSettings(this.loginInfo?.clientId);
    }
  }
};
</script>
